import { render, staticRenderFns } from "./AgTableDangerIcon.vue?vue&type=template&id=5a50b1d6&scoped=true&"
import script from "./AgTableDangerIcon.vue?vue&type=script&lang=js&"
export * from "./AgTableDangerIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a50b1d6",
  null
  
)

export default component.exports